import PropTypes from 'prop-types';

const Toolbar = ({
  currentPath,
  selectedItems,
  clipboard,
  onNavigateUp,
  onRefresh,
  onUpload,
  onCreateFolder,
  onCopy,
  onCut,
  onRename,
  onChmod,
  setClipboard,
  onDelete,
  onPaste,
  disabled,
  baseApiUrl
}) => {
  const handleDownload = () => {
    if (selectedItems.length !== 1) return;

    const item = selectedItems[0];
    if (item.type === 'directory') {
      alert('Verzeichnisse können derzeit nicht heruntergeladen werden');
      return;
    }

    const baseUrl = baseApiUrl || '/usercp/filemanager/api';
    window.location.href = `${baseUrl}/download?path=${encodeURIComponent(item.path)}`;
  };

  return (
    <div className="toolbar">
      <div className="btn-toolbar" role="toolbar">
        <div className="btn-group">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={onNavigateUp}
            disabled={disabled || currentPath === '/'}
            title="Hoch"
          >
            <i className="fa fa-level-up" />
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={onRefresh}
            disabled={disabled}
            title="Aktualisieren"
          >
            <i className="fa fa-refresh" />
          </button>
        </div>

        <div className="btn-group">
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={onUpload}
            disabled={disabled}
            title="Datei hochladen"
          >
            <i className="fa fa-upload mr-1" />
            Upload
          </button>
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={onCreateFolder}
            disabled={disabled}
            title="Neuer Ordner"
          >
            <i className="fa fa-folder-o mr-1" />
            Ordner
          </button>
        </div>

        <div className="btn-group">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={onCopy}
            disabled={disabled || selectedItems.length === 0}
            title="Kopieren"
          >
            <i className="fa fa-copy" />
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={onCut}
            disabled={disabled || selectedItems.length === 0}
            title="Ausschneiden"
          >
            <i className="fa fa-cut" />
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={onPaste}
            disabled={disabled || !clipboard || clipboard.items.length === 0}
            title="Einfügen"
          >
            <i className="fa fa-paste" />
            {clipboard && clipboard.items.length > 0 && (
              <span className="badge badge-secondary ml-1">{clipboard.items.length}</span>
            )}
          </button>
        </div>

        <div className="btn-group">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={onRename}
            disabled={disabled || selectedItems.length !== 1}
            title="Umbenennen"
          >
            <i className="fa fa-i-cursor" />
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={onChmod}
            disabled={disabled || selectedItems.length !== 1}
            title="Berechtigungen"
          >
            <i className="fa fa-lock" />
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={handleDownload}
            disabled={disabled || selectedItems.length !== 1 || selectedItems[0]?.type === 'directory'}
            title="Herunterladen"
          >
            <i className="fa fa-download" />
          </button>
        </div>

        <div className="btn-group">
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={onDelete}
            disabled={disabled || selectedItems.length === 0}
            title="Löschen"
          >
            <i className="fa fa-trash" />
          </button>
        </div>
      </div>
    </div>
  );
};

Toolbar.propTypes = {
  currentPath: PropTypes.string.isRequired,
  selectedItems: PropTypes.array.isRequired,
  clipboard: PropTypes.object,
  onNavigateUp: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  onCreateFolder: PropTypes.func.isRequired,
  onCopy: PropTypes.func.isRequired,
  onCut: PropTypes.func.isRequired,
  onRename: PropTypes.func.isRequired,
  onChmod: PropTypes.func.isRequired,
  setClipboard: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  baseApiUrl: PropTypes.string,
};

export default Toolbar;